/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { ApButtonMain, ApSimpleDropdown } from '@alixpartners/ui-components';

import {
	getChartDataForMarketAnalysis,
	getDatesSKU,
	getModuleFilter,
	getSKUForMarketAnalysis,
	getSuppliersForMarketAnalysis,
} from 'utils/apiRequests';
import { DateRangeWrapper } from '../../CategoryDashboard.styles';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import {
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
} from 'CategoryManagement/utils';
import {
	SectionWrapper,
	Breadcrumbs,
	FilterWrapper,
	SingleFilterWrapper,
	NoData,
	BreakdownWrapper,
	BreakdownByWrapper,
} from './MarketEffect.styles';
import Monthly from './Charts/Monthly';
import Quarterly from './Charts/Quarterly';
import SemiAnnually from './Charts/SemiAnnually';
import Annually from './Charts/Annually';
import MultiSelect from '../../SkuSettings/components/MultiSelect/MultiSelect';
import {
	checkAndFormat,
	checkAndFormatSuppliers,
	filterInitialOptions,
} from 'SpeedToMarket/Tabs/CategoryWidget/utils';

const breakDownOptions = [
	{ label: 'Monthly', value: 0 },
	{ label: 'Quarterly', value: 1 },
	{ label: 'Semi Annually', value: 2 },
	{ label: 'Annually', value: 3 },
];

const MarketEffect = ({ modelId, setContent }) => {
	const [filterData, setFilterData] = useState(
		localStorage.getItem(`marketFilters-${modelId}`) === null
			? filterInitialOptions
			: JSON.parse(localStorage.getItem(`marketFilters-${modelId}`))
	);
	const [isFilterLoading, setIsFilterLoading] = useState(
		localStorage.getItem(`marketFilters-${modelId}`) === null ? true : false
	);
	const [supplierLoading, setSupplierLoading] = useState(false);
	const [breakDownBy, setBreakDownBy] = useState(
		localStorage.getItem('breakDownType') === null
			? breakDownOptions[0]
			: JSON.parse(localStorage.getItem('breakDownType'))
	);
	const [isSKULoading, setIsSKULoading] = useState(false);
	const [chartData, setChartData] = useState([]);
	const [isChartLoading, setIsChartLoading] = useState(false);

	useEffect(() => {
		if (localStorage.getItem(`marketFilters-${modelId}`) === null) {
			setIsFilterLoading(true);
			const payload = {
				modelId: modelId,
			};
			try {
				Promise.all([getModuleFilter(payload), getDatesSKU()]).then(
					([filterResponse, dateResponse]) => {
						const formatedCategory1Options = checkAndFormat(
							filterResponse.data.category1
						);
						const formatedCategory2Options = checkAndFormat(
							filterResponse.data.category2
						);
						const formatedCategory3Options = checkAndFormat(
							filterResponse.data.category3
						);
						const formatedCommodityCodeOptions = checkAndFormat(
							filterResponse.data.commodityCode
						);
						const formatedcommodityFamilyOptions = checkAndFormat(
							filterResponse.data.commodityFamily
						);
						const minDate = dateResponse?.data?.minDate.split('T')[0];
						const maxDate = dateResponse?.data?.maxDate.split('T')[0];
						const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
						const selectedRange = getDateRangeMonthYearState(minDate, maxDate);
						setFilterData(prevState => ({
							...prevState,
							category_1: {
								...prevState.category_1,
								options: formatedCategory1Options,
								selectedOption: [],
							},
							category_2: {
								...prevState.category_2,
								options: formatedCategory2Options,
								selectedOption: [],
							},
							category_3: {
								...prevState.category_3,
								options: formatedCategory3Options,
								selectedOption: [],
							},
							commodity_Code: {
								...prevState.commodity_Code,
								options: formatedCommodityCodeOptions,
								selectedOption: [],
							},
							commodity_Family: {
								...prevState.commodity_Family,
								options: formatedcommodityFamilyOptions,
								selectedOption: [],
							},
							dateRange: {
								srcRange: wholeRange,
								stateRange: selectedRange,
							},
						}));
						// localStorage.setItem(
						// 	`marketFilters-${modelId}`,
						// 	JSON.stringify({
						// 		...filterData,
						// 		category_1: {
						// 			...filterData.category_1,
						// 			options: formatedCategory1Options,
						// 			selectedOption: [],
						// 		},
						// 		category_2: {
						// 			...filterData.category_2,
						// 			options: formatedCategory2Options,
						// 			selectedOption: [],
						// 		},
						// 		category_3: {
						// 			...filterData.category_3,
						// 			options: formatedCategory3Options,
						// 			selectedOption: [],
						// 		},
						// 		commodity_Code: {
						// 			...filterData.commodity_Code,
						// 			options: formatedCommodityCodeOptions,
						// 			selectedOption: [],
						// 		},
						// 		commodity_Family: {
						// 			...filterData.commodity_Family,
						// 			options: formatedcommodityFamilyOptions,
						// 			selectedOption: [],
						// 		},
						// 		dateRange: {
						// 			srcRange: wholeRange,
						// 			stateRange: selectedRange,
						// 		},
						// 	})
						// );
						setIsFilterLoading(false);
						return { response: filterResponse.data, dateResponse };
					}
				);
			} catch (error) {
				console.log(error);
				setIsFilterLoading(false);
			}
		}
		localStorage.getItem('breakDownType') === null
			? localStorage.setItem(
					'breakDownType',
					JSON.stringify(breakDownOptions[0])
			  )
			: JSON.parse(localStorage.getItem('breakDownType'));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(
		() => {
			if (filterData.sku.selectedOption.length !== 0) {
				loadCharts(breakDownBy.value);
			}
		}, // eslint-disable-next-line
		[breakDownBy]
	);

	const handleGetSuppliers = async filters => {
		setSupplierLoading(true);
		await getSuppliersForMarketAnalysis({
			category1: filters.category_1.selectedOption,
			category2: filters.category_2.selectedOption,
			category3: filters.category_3.selectedOption,
			commodityFamily: filters.commodity_Family.selectedOption,
			commodityCode: filters.commodity_Code.selectedOption,
		})
			.then(response => {
				const formattedSupplierArray = response.data;
				const formatedSupplierOptions = checkAndFormatSuppliers(
					formattedSupplierArray
				);
				setFilterData(prevState => ({
					...prevState,
					supplier: {
						...prevState.supplier,
						options: formatedSupplierOptions,
						selectedOption: [],
					},
				}));
			})
			.then(() => {
				setSupplierLoading(false);
			})
			.catch(() => {
				setSupplierLoading(false);
			});
	};

	const onFilterChangeHandler = (key, value) => {
		setFilterData(prevState => {
			if (key !== 'supplier') {
				handleGetSuppliers({
					...prevState,
					[key]: {
						...prevState[key],
						selectedOption: value,
					},
					sku: {
						options: [],
						selectedOption: [],
					},
				});
			}
			// localStorage.setItem(
			// 	`marketFilters-${modelId}`,
			// 	JSON.stringify({
			// 		...prevState,
			// 		[key]: {
			// 			...prevState[key],
			// 			selectedOption: value,
			// 		},
			// 		sku: {
			// 			options: [],
			// 			selectedOption: [],
			// 		},
			// 	})
			// );

			return {
				...prevState,
				[key]: {
					...prevState[key],
					selectedOption: value,
				},
				sku: {
					options: [],
					selectedOption: [],
				},
			};
		});
		setChartData([]);
	};

	const onSupplierChangeHandler = (key, value) => {
		setFilterData(prevState => {
			// localStorage.setItem(
			// 	`marketFilters-${modelId}`,
			// 	JSON.stringify({
			// 		...prevState,
			// 		[key]: {
			// 			...prevState[key],
			// 			selectedOption: value,
			// 		},
			// 	})
			// );
			getSKU({
				...prevState,
				[key]: {
					...prevState[key],
					selectedOption: value,
				},
			});
			return {
				...prevState,
				[key]: {
					...prevState[key],
					selectedOption: value,
				},
			};
		});
		setChartData([]);
	};

	const getSKU = async filters => {
		setIsSKULoading(true);
		await getSKUForMarketAnalysis({
			category1: filters.category_1.selectedOption,
			category2: filters.category_2.selectedOption,
			category3: filters.category_3.selectedOption,
			commodityFamily: filters.commodity_Family.selectedOption,
			commodityCode: filters.commodity_Code.selectedOption,
			supplier: filters.supplier.selectedOption,
			serialNumber: [],
		}).then(response => {
			if (response.data.length > 0) {
				const formatedSKUOptions = response.data
					.filter(x => x !== null)
					.map(x => {
						return { label: x.sku, value: x.sku };
					});
				if (formatedSKUOptions.length === 1) {
					setFilterData(prevState => {
						localStorage.setItem(
							`marketFilters-${modelId}`,
							JSON.stringify({
								...prevState,
								sku: {
									options: formatedSKUOptions,
									selectedOption: formatedSKUOptions.map(x => x.value),
								},
							})
						);
						return {
							...prevState,
							sku: {
								...prevState.sku,
								options: formatedSKUOptions,
								selectedOption: formatedSKUOptions.map(x => x.value),
							},
						};
					});
				} else {
					setFilterData(prevState => ({
						...prevState,
						sku: {
							...prevState.sku,
							options: formatedSKUOptions,
							selectedOption: [],
						},
					}));
				}
				setIsSKULoading(false);
			} else {
				setFilterData(prevState => ({
					...prevState,
					sku: {
						...prevState.sku,
						options: [],
						selectedOption: [],
					},
				}));
				setIsSKULoading(false);
			}
		});
	};

	const onChangeSKUHandler = (key, value) => {
		setFilterData(prevState => {
			// localStorage.setItem(
			// 	`marketFilters-${modelId}`,
			// 	JSON.stringify({
			// 		...prevState,
			// 		[key]: {
			// 			...prevState[key],
			// 			selectedOption: value,
			// 		},
			// 	})
			// );
			return {
				...prevState,
				[key]: {
					...prevState[key],
					selectedOption: value,
				},
			};
		});
	};

	const onBreakDownChangeHandler = v => {
		localStorage.setItem('breakDownType', JSON.stringify(v));
		setBreakDownBy(v);
	};

	const onApplyFilterHandler = () => {
		loadCharts(breakDownBy.value);
		localStorage.setItem(
			`marketFilters-${modelId}`,
			JSON.stringify(filterData)
		);
	};

	const loadCharts = async value => {
		setIsChartLoading(true);
		await getChartDataForMarketAnalysis({
			supplier: filterData.supplier.selectedOption,
			startDate:
				'01' +
				'-' +
				filterData.dateRange.stateRange.from.monthNumber +
				'-' +
				filterData.dateRange.stateRange.from.year,
			endDate:
				'01' +
				'-' +
				filterData.dateRange.stateRange.to.monthNumber +
				'-' +
				filterData.dateRange.stateRange.to.year,
			sku: filterData.sku.selectedOption,
			type: value,
		})
			.then(response => {
				if (response.succeeded) {
					if (response.data.length > 0) {
						setChartData(response.data);
					} else {
						setChartData([]);
					}
				} else {
					setChartData([]);
				}
			})
			.then(() => setIsChartLoading(false));
	};

	const isSkuSelected = useMemo(
		() => filterData?.sku?.selectedOption.length !== 0,
		[filterData]
	);

	return (
		<SectionWrapper>
			<Breadcrumbs>
				<span onClick={() => setContent(0)}>Segmented Data</span>&nbsp;/&nbsp;<span
				>
					Market Effect Analysis
				</span>
			</Breadcrumbs>

			<FilterWrapper>
				<SingleFilterWrapper>
					<MultiSelect
						name="category_1"
						label="Category 1"
						options={filterData.category_1.options}
						selected={filterData.category_1.selectedOption}
						disabled={false}
						isLoading={isFilterLoading}
						onChange={v => {
							onFilterChangeHandler('category_1', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="category_2"
						label="Category 2"
						options={filterData.category_2.options}
						selected={filterData.category_2.selectedOption}
						disabled={false}
						isLoading={isFilterLoading}
						onChange={v => {
							onFilterChangeHandler('category_2', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="category_3"
						label="Category 3"
						options={filterData.category_3.options}
						selected={filterData.category_3.selectedOption}
						disabled={false}
						isLoading={isFilterLoading}
						onChange={v => {
							onFilterChangeHandler('category_3', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="commodity_code"
						label="Commodity Code"
						options={filterData.commodity_Code.options}
						selected={filterData.commodity_Code.selectedOption}
						disabled={false}
						isLoading={isFilterLoading}
						onChange={v => {
							onFilterChangeHandler('commodity_Code', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="commodity_family"
						label="Commodity Family"
						options={filterData.commodity_Family.options}
						selected={filterData.commodity_Family.selectedOption}
						disabled={false}
						isLoading={isFilterLoading}
						onChange={v => {
							onFilterChangeHandler('commodity_Family', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="supplier"
						label="Supplier"
						options={filterData.supplier.options}
						selected={filterData.supplier.selectedOption}
						disabled={supplierLoading}
						isLoading={supplierLoading}
						onChange={v => {
							onSupplierChangeHandler('supplier', v);
						}}
					/>
				</SingleFilterWrapper>

				<SingleFilterWrapper>
					<MultiSelect
						name="sku"
						label="SKU"
						options={filterData.sku.options}
						selected={filterData.sku.selectedOption}
						disabled={filterData.supplier.selectedOption.length === 0}
						isLoading={isSKULoading}
						onChange={v => {
							onChangeSKUHandler('sku', v);
						}}
					/>
				</SingleFilterWrapper>

				<DateRangeWrapper>
					{!isFilterLoading && (
						<MonthPicker
							srcRange={filterData.dateRange.srcRange}
							stateRange={filterData.dateRange.stateRange}
							onConfirm={e => {
								setFilterData(prevState => ({
									...prevState,
									dateRange: {
										...prevState.dateRange,
										stateRange: e,
									},
								}));
							}}
						/>
					)}
				</DateRangeWrapper>

				<div>
					<ApButtonMain
						small={true}
						onClick={onApplyFilterHandler}
						disabled={
							filterData?.sku?.selectedOption.length === 0 || isChartLoading
						}
					>
						Apply Filters
					</ApButtonMain>
				</div>
			</FilterWrapper>

			<BreakdownWrapper>
				{filterData?.sku?.selectedOption.length !== 0 &&
					chartData.length !== 0 && (
						<>
							<BreakdownByWrapper>Breakdown By:</BreakdownByWrapper>
							<ApSimpleDropdown
								options={breakDownOptions}
								selected={breakDownBy}
								onChange={onBreakDownChangeHandler}
							/>
						</>
					)}
			</BreakdownWrapper>

			{!isSkuSelected ? (
				<NoData>Select SKU in filters to populate the charts.</NoData>
			) : (
				<>
					{breakDownBy.value === 0 && (
						<Monthly chartData={chartData} isChartLoading={isChartLoading} />
					)}

					{breakDownBy.value === 1 && (
						<Quarterly chartData={chartData} isChartLoading={isChartLoading} />
					)}

					{breakDownBy.value === 2 && (
						<SemiAnnually
							chartData={chartData}
							isChartLoading={isChartLoading}
						/>
					)}

					{breakDownBy.value === 3 && (
						<Annually chartData={chartData} isChartLoading={isChartLoading} />
					)}
				</>
			)}
			<></>
		</SectionWrapper>
	);
};

export default MarketEffect;
